export { default } from 'pages/integration/files';
